import React from 'react'
import { Platform, Pressable } from 'react-native'
import { useTranslation } from 'react-i18next'
import { router } from 'expo-router'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'
import { useCustomer } from 'hooks/useSession'

const getGreeting = () => {
  const date = new Date()
  const hour = date.getHours()

  if (hour < 6) return 'night'
  if (hour < 12) return 'morning'
  if (hour < 18) return 'afternoon'
  if (hour < 22) return 'evening'
  return 'night'
}

export default function WelcomeSection() {
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const { t } = useTranslation(['ui', 'customer'])
  const text = 'customer:home.sections.welcome'

  const customer = useCustomer()
  const name = customer?.first_name || t('ui:stage.customer')

  const onPress = () => router.navigate('/customer/account')

  return (
    <>
      <Pressable
        onPress={onPress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className="flex-1"
      >
        <TileBlur
          variant="large"
          title={`${t(`${text}.title.${getGreeting()}`)}, ${name}`}
          desc={t(`${text}.desc`, { name })}
          cta={
            <Button
              noninteractive
              animation={animation}
              onPress={onPress}
              size="sm"
              variant="outlined"
              label={t(`${text}.cta`)}
            />
          }
          glassProps={{
            animation,
            image: require('@/images/welcome.png'),
            imageStyle: {
              transform: [{ translateX: 50 }, { translateY: 10 }],
            },
            blur: Platform.select({ default: 100, web: 50 }),
            blurStyle: {
              opacity: 0.66,
              transform: [
                { translateX: 40 },
                { translateY: -20 },
                { scale: 0.75 },
                { rotate: Platform.select({ default: '-15deg', web: '0deg' }) },
              ],
            },
          }}
        />
      </Pressable>
    </>
  )
}
